import { DialogContent } from '@mui/material'
import React from 'react'

import Dialog from '@/app/component/atom/dialog'
import DialogHeader from '@/app/component/atom/dialog-header'
import { useSendFeedback } from '@/app/module/user/hooks/use-send-feedback'

import FeedbackForm, { FeedbackFormValues } from './feedback-form'

type FeedbackDialogProps = {
  open: boolean
  onClose: () => void
}

const FeedbackDialog: React.FC<FeedbackDialogProps> = ({ open, onClose }) => {
  const [sendFeedback, { isLoading: isSending }] = useSendFeedback()

  const handleSubmit = async (data: FeedbackFormValues) => {
    const success = await sendFeedback({
      message: data.message.trim(),
    })

    if (success) {
      onClose()
    }
  }

  const handleClose = () => {
    if (!isSending) {
      onClose()
    }
  }

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogHeader icon="feedback" title="Send Feedback" onClose={handleClose} />
      <DialogContent>
        <FeedbackForm isSubmitting={isSending} shouldReset={!open} onSubmit={handleSubmit} />
      </DialogContent>
    </Dialog>
  )
}

export default FeedbackDialog
